import { LIMITS } from './constants';
import type { RegistrantType } from './models';

/**
 * כללי בקשות השינוי מהקישור האישי — משותפים לטופס ולשרת.
 * קבלן: כמות חדשה (0 = ביטול הגעה). עובד עצמאי: רק ביטול הגעה (0).
 */

export type ChangeRequestValidation =
  | { ok: true; value: { requestedCount: number; note: string } }
  | { ok: false; error: string };

export function validateChangeRequest(
  type: RegistrantType,
  currentCount: number,
  requestedCount: unknown,
  note: unknown,
  maxWorkers: number = LIMITS.maxWorkers,
): ChangeRequestValidation {
  const n = typeof requestedCount === 'number' ? requestedCount : Number.NaN;
  const text = typeof note === 'string' ? note.trim() : '';
  if (text.length > LIMITS.maxRequestNoteLength) return { ok: false, error: `ההערה ארוכה מדי (עד ${LIMITS.maxRequestNoteLength} תווים)` };
  if (!Number.isInteger(n)) return { ok: false, error: 'יש להזין מספר שלם' };
  if (type === 'worker') {
    if (n !== 0) return { ok: false, error: 'עובד עצמאי יכול לבקש רק ביטול הגעה' };
  } else {
    if (n < 0 || n > maxWorkers) return { ok: false, error: `הכמות צריכה להיות בין 0 ל-${maxWorkers}` };
    if (n === currentCount) return { ok: false, error: 'זו כבר הכמות הנוכחית' };
  }
  return { ok: true, value: { requestedCount: n, note: text } };
}

export function describeRequest(previousCount: number, requestedCount: number): string {
  if (requestedCount === 0) return 'ביטול הגעה';
  return requestedCount > previousCount ? `הגדלה ל-${requestedCount}` : `הקטנה ל-${requestedCount}`;
}

/** אסימון אישי: 43 תווי base64url (256 ביט). בדיקת צורה לפני כל גישה למסד. */
export const PERSONAL_TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;
export const REGISTRATION_SLUG_RE = /^[a-z0-9]{6,20}$/;
export const ACCESS_CODE_RE = /^\d{6}$/;
